import { ThemeConfig } from "antd";
import { createContext } from "react";
import appTheme from "../../../appTheme";
import { getSystemColorScheme } from "../../../utils/cssUtils";
import { Settings } from "../SettingsContext";

let _colorScheme = getSystemColorScheme();

/**
 * Function to get the current color scheme without the need to use the context.
 */
export function getColorScheme(): NonNullable<Settings["colorScheme"]> {
  return _colorScheme;
}

/**
 * Function to set the current color scheme without the need to use the context.
 */
export function setColorScheme(value: NonNullable<Settings["colorScheme"]>): void {
  _colorScheme = value;
}

export const AntDesignConfigContext = createContext<ThemeConfig>(appTheme.light);
